import { createAction } from 'redux-actions';
export const recordApplicationBuildId = createAction('RECORD_APPLICATION_BUILDID');
export const setReactiveSessionStorage = createAction('SET_REACTIVE_SESSION_STORAGE');
